var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"block-dark block-kopf-dark",class:[ _vm.colClass ]},[_c('span',{staticClass:"primary-headline-text text-white"},[_vm._v(_vm._s(_vm.headline))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }